module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/diagram-c8ea895df65dc5aee3f012f7b41dc9da.svg";